import type { BackendErrorsLocale } from "@/locales/fr/backend-errors";

const backendErrors: BackendErrorsLocale = {
  backendErrors: {
    error: {
      unexpected: "An unexpected error occurred",
      siteHasNoPdl: "The site has no MPAN",
    },
    signature: {
      requiresEscIntervention: "The site has no eligible intervention for sale",
      requiresInstallationAppointment: "No installation / upgrade appointment scheduled for this site could be found",
    },
  },
};

export default backendErrors;
